import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import { useAuth } from "../../../auth/auth";
import styles from "./GenerateFatigues.module.css";
import { generateFRIReport, getAllClients } from "../../../api/apiCall";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useUKRailWeek } from "../../../hooks/useUKRailWeek";

const GenerateFatigues = () => {
  const { state } = useAuth();
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState<any>([]);
  const {currentWeek, currentYear} = useUKRailWeek();

  const { register, handleSubmit, control } = useForm<any>({
    defaultValues: {
      week: currentWeek,
      year: currentYear,
      clientId: "",
    },
  });

  const getClients = async () => {
    const response = await getAllClients(state.user?.token);
    if (response) {
      setClients(response);
    }
  };

  const onSubmit = async (data: any) => {
    setLoading(true);
    const response = await generateFRIReport(state.user?.token, data);
    if (response?.status === 200) {
      setLoading(false);
    } else {
      setLoading(false);
      toast.error("Something went wrong!");
    }
  };

  useEffect(() => {
    getClients();
  }, []);

  return (
    <>
      <div className={styles.formContainer}>
        <div className={styles.timesheetForm}>
          <Box>
            <div className={styles.timesheetFormDiv}>
              <h2 className={styles.timesheetTitle}>Generate Advisory Fatigues</h2>
              <p className={styles.timesheetSubtitle}>
                 Generate Advisory Fatigues for week
              </p>
              <TextField
                variant="outlined"
                label="Week"
                placeholder="Enter Week"
                className={styles.exportButton}
                style={{ margin: 15 }}
                {...register("week")}
              />
              <TextField
                variant="outlined"
                label="Year"
                placeholder="Enter Year"
                className={styles.exportButton}
                style={{ margin: 15 }}
                {...register("year")}
              />
              <Controller
                name="clientId"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    options={clients}
                    getOptionLabel={(option: any) => option.companyName || ""}
                    isOptionEqualToValue={(option: any, value: any) =>
                      option.companyName === value?.companyName
                    }
                    style={{ margin: 15 }}
                    value={field.value || null}
                    onChange={(_, value) => field.onChange(value)}
                    clearOnEscape
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Client"
                        placeholder="Choose a Client"
                        size="medium"
                        sx={{ width: "400px" }}
                      />
                    )}
                  />
                )}
              />
              <Button
                variant="contained"
                disabled={loading}
                size="medium"
                style={{
                  boxShadow: "none",
                  marginTop: 25,
                  backgroundColor: "#1976d2",
                  color: "white",
                }}
                className={styles.exportButton}
                onClick={handleSubmit(onSubmit)}
              >
                {loading ? (
                  <CircularProgress size={25} style={{ color: "white" }} />
                ) : (
                  "Export Fatigues"
                )}
              </Button>
              <div
                style={{ textAlign: "center", margin: 4, marginBottom: -10 }}
              >
                {loading && "This might take a while"}
              </div>
            </div>
          </Box>
        </div>
      </div>
    </>
  );
};

export default GenerateFatigues;
